/**
 * TimelinePage — B1.5 Daily Timeline route entry.
 *
 * Intentionally thin: the page is a fixed-height container that hosts the
 * `DailyTimelineContainer` smart wrapper, which owns data, swipe actions,
 * optimistic status changes, offline detection, and sheet orchestration.
 *
 * Data cache is shared with `<WeeklyCalendarContainer />` via React Query
 * keys in `useAppointments` — status changes made here appear instantly
 * on the weekly view and vice versa.
 */
import { DailyTimelineContainer } from '@/features/appointments';

export function TimelinePage(): JSX.Element {
  return (
    <div className="h-full min-h-0 flex flex-col">
      <DailyTimelineContainer />
    </div>
  );
}
